<template>
  <div class="story">
    <div class="loader" v-if="!dataLoaded">loading ...</div>
    <div class="story-page" v-if="dataLoaded">

    <leaflet-map :currentScreenId="id" :hidden="isIntro" :isExplore="false" :locale="$i18n.locale"/>

    <div class="gradient"></div>

    <div class="cover-image" :class="{hidden: !isIntro}">
      <img src="@/assets/images/cover-bg-2.png"/>
    </div>

    <div class="paper-texture" v-if="!isExplore"></div>
    <div class="wrapper">
      <div class="content-wrapper">
        <navigation v-if="!isLanding" :noTimeline="isIntro || isEnd" :id="id"/>
        <screens :key="lang"/>
      </div>
    </div>
    <div class="menu-button-container" v-if="!isLanding" @click="openMenu">
      <img class="menu-icon" src="@/assets/images/menu.svg"/>
      <label>Menu</label>
    </div>
    <noah-menu v-if="menuOpened"/>
    <div class="controls">
      <switch-lang/>
      <autoplay/>
    </div>

    <transition name="slide-fade">
      <modal v-if="modalOpened" @close="closeModal()"/>
    </transition>

    </div>
  </div>

</template>

<script>
import Map from '@/components/Map'
import Screens from '@/components/Screens'
import Navigation from '@/components/Navigation'
import Modal from '@/components/Modal'
import Autoplay from '@/components/Autoplay'
import SwitchLang from '@/components/SwitchLang'
import Menu from '@/components/Menu'

export default {
  name: 'story',
  computed: {
    currentUrl () {
      return window.location.hash
    },
    id () {
      return this.isExplore ? 'explore-the-land' : this.$store.state.eventId
    },
    isExplore () {
      return this.$route.path === '/explore-the-land'
      // return this.id === 'explore-the-land'
    },
    isIntro () {
      return !this.isExplore && (this.id === 'introduction' || this.id === 'welcome')
    },
    isLanding () {
      return !this.isExplore && this.id === 'welcome'
    },
    isEnd () {
      return this.id === 'end-of-story'
    },

    dataLoaded () {
      return this.$store.state.storyDataLoaded &&
        this.$store.state.campSitesDataLoaded &&
        this.$store.state.mapDataLoaded
    },
    modalOpened () {
      return this.$store.state.modal.opened
    },
    menuOpened () {
      return this.$store.state.menuOpened
    },
    lang () {
      return this.$store.state.lang
    }
  },
  components: {
    LeafletMap: Map,
    Screens,
    Navigation,
    Modal,
    NoahMenu: Menu,
    Autoplay,
    SwitchLang
  },
  mounted () {
    // window.addEventListener('popstate', e => {
    //   window.location.href = '/'
    // }, false)
    this.$store.dispatch('loadMediaData')
    this.$store.dispatch('loadMapData')
  },
  methods: {
    navigateTo (id) {
      window.location.href = '#' + id
    },
    closeModal () {
      this.$store.dispatch('unselectGeometry')
    },
    openMenu () {
      this.$store.commit('setMenuOpened', true)
    }
  }
}
</script>

<style lang="scss">
#map {
  pointer-events:auto;
  position:absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.cover-image {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
  opacity: 1;
  transition: opacity 2s;
  @media only screen and (max-width: 768px) {
      width: 20%;
  }
  img {
    height: 720px;
  }
}
.cover-image.hidden {
  opacity: 0;
}
.gradient, .paper-texture   {
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  background-repeat: no-repeat;
}
.gradient  {
  content: "";
  background-image: linear-gradient(90deg, #F1F1F0 50%, rgba(241,241,240,0.00) 100%);
  width: 720px;
  background-size: 100% 100%;
  z-index: 0;
}
.paper-texture {
    background-image: url("../assets/images/paper_texture.png");
    width: 100%;
    background-size: 100% 100%;
    z-index: 0;
}
.loader {
  z-index: 2;
}
.story-page {
   display: flex;
  z-index: 2;
  align-items: center;
  height: 100vh;
  .wrapper {
    position: relative;
    height: 100%;
    @media only screen and (max-width: 768px) {
      // width: 100%;
    }

    border: none;
    .content-wrapper,.loader {
      // position: absolute;
      pointer-events: auto;
      height: 100%;
      display: flex;
      flex-direction: row;
    }
  }
  .controls {
    position: absolute;
    display: flex;
    flex-direction: row;
    margin: 64px;
    bottom: 0;
    right: 0;
    background: radial-gradient(ellipse at center, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
}
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-720px);
  opacity: 0;
}

.menu-button-container {
    position: absolute;
    top: 48px;
    left: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    cursor: pointer;
    pointer-events: auto;
    @media only screen and (max-width: 768px) {
      left: auto;
      right: 24px;
      top: 24px;
      flex-direction: row-reverse;
    }
  .menu-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  label {
    margin: 0px 15px;
    font-family: Georgia;
    font-size: 15px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
  }
}

</style>
